import { render, staticRenderFns } from "./EmploymentStatusSelect.vue?vue&type=template&id=2faf2214"
import script from "./EmploymentStatusSelect.vue?vue&type=script&lang=js"
export * from "./EmploymentStatusSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faf2214')) {
      api.createRecord('2faf2214', component.options)
    } else {
      api.reload('2faf2214', component.options)
    }
    module.hot.accept("./EmploymentStatusSelect.vue?vue&type=template&id=2faf2214", function () {
      api.rerender('2faf2214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/loan/EmploymentStatusSelect.vue"
export default component.exports